import React from 'react';

import IconComponent, { type IIconsProps } from '../../Icon';

/**
 * Types
 */

export interface IndicatorProps extends Pick<IIconsProps, 'iconName'> {}

/**
 * Component
 */

export default function Indicator({ iconName }: IndicatorProps) {
  return (
    <div className="bg-site-primary-600 rounded-[50%]">
      <IconComponent iconName={iconName} size="IconM" className="bg-site-neutrals-0" />
    </div>
  );
}
